//CSS
import "../../Components/Page/Page.css";
import "../../Components/Page/Page2.css";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";

//icons
import { faIndustry, faBullseye, faTriangleExclamation, faBrain } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ProductsIntro: React.FC = () => {
    return (
        <div id="Goals" className="sectionContainer">
            <SecHeader title="Intro" />

            <SubSection isSplit={false}>
                <div className="description-container">
                    <p>
                        <div className="iconRow_parent">
                            <div className="iconRow">
                                <FontAwesomeIcon icon={faIndustry} size="2x" className="iconRow__icon" />
                                <div className="iconRow__text">
                                    <b className="iconRow__text"> The Internal Combustion Engine Industry is Stagnant and Declining</b>
                                    <br />
                                    <br />With Wankel in 1957 inventing the last new engine geometry.<br />
                                </div>
                            </div>

                        </div>
                        <div className="iconRow_parent">
                            <div className="iconRow">
                                <FontAwesomeIcon icon={faTriangleExclamation} size="2x" className="iconRow__icon" />
                                <div>
                                    <b className="iconRow__text"> The Industry is Focused on EVs, but EVs Have Obvious Hard Limits</b>
                                    <br />
                                    <br />Range, costs, charging station limits, rare earths & materials issues, fragile supply chains, reduced jobs, end of life pollution, and limits due to vehicle Sizes and battery energy density.<br />
                                </div>
                            </div>
                        </div>
                        <div className="iconRow_parent">
                            <div className="iconRow">
                                <FontAwesomeIcon icon={faBullseye} size="2x" className="iconRow__icon" />
                                <div>
                                    <b className="iconRow__text"> Positive Disruption and New Engine Designs are Overdue</b>
                                    <br />
                                    <br />We found them - we tested them - and - we patented them<br />
                                </div>
                            </div>
                        </div>
                        <div className="iconRow_parent">
                            <div className="iconRow">

                                <FontAwesomeIcon icon={faBrain} size="2x" className="iconRow__icon" />
                                <div>
                                    <b className="iconRow__text"> Our Solutions​​</b>
                                    <br />
                                    <ul>
                                        <li>E-SPEC™ Software</li>
                                        <li>Elf-Tech™ CAD Designs</li>
                                        <li>Engine Modeling</li>
                                    </ul>
                                    <br />
                                </div>

                            </div>
                        </div>
                    </p>{" "}
                </div>
            </SubSection >
        </div >
    );
};

export default ProductsIntro;